/**
 * Created by Administrator on 2017/10/27.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { CommonService } from "../service/common";
import { FileUpload } from "../service/file-upload";
import { FormBuilder } from "@angular/forms";
import { API } from "../config/api-config";
declare var alertify: any;
declare var $: any;
@Component({
  templateUrl: './filmEdit.html'
})

export class FilmEdit implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private fileupload: FileUpload,
    private location: Location,
    private common: CommonService
  ) { }





  private contentEn: string = '<p></p>';
  private contentTc: string = '<p></p>';
  private filmTypeData: any = [];
  private dataFilmType: any = [];
  private newFilmType: any = [];
  private hasChecked: boolean = true;
  private id: number = 0;
  private isCreate: boolean = false;
  private language = 'tc';
  private data: any = {
    "active": "",
    "contentEn": "",
    "contentTc": "",
    "defFree": false,
    "defRecommend": false,
    "filmTypes": [],
    "id": "",
    "keyWordsEn": "",
    "keyWordsTc": "",
    "publishTime": "",
    "titleEn": "",
    "titleTc": "",
    "updatedBy": "",
    "urlEn": "",
    "urlTc": "",
    "defaultFilm": ""
  }
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
    this.initTime();
    //this.getFilmTypeData();
    this.getData();
    if (this.id == 0) {
      this.isCreate = true;
      this.hasChecked = false;
    }
  }
  private showByLanguage(type: string) {
    this.language = type;
  }
  private initTime() {
    setTimeout(res => {
      $("#publishTime").datetimepicker({
        language: 'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn: 1,
        autoclose: true,
        startDate: this.common.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      })

    })

  }
  private getData(): void {
    if (this.id != 0) {
      this.HttpService.getData(API.film + '/' + this.id)
        .then(res => {
          this.data = res.data;
          this.data.active = res.data.active == 1 ? true : false;
          this.data.defaultFilm = res.data.defaultFilm == 1 ? true : false;
          this.contentEn = this.data.contentEn;
          this.contentTc = this.data.contentTc;
          if (typeof this.data.publishTime == 'object') {
            this.data.publishTime = '';
          }
          this.dataFilmType = this.data.filmTypes;
          console.log('90=', this.data.filmTypes)
          this.getFilmTypeData();
        });
    } else {
      this.getFilmTypeData();
    }
    /* if(this.data.filmTypeData.length>0){
       this.hasChecked = true;
     }*/
  }



  private getFilmTypeData(): void {
    this.HttpService.getData(API.filmType)
      .then(res => {
        this.filmTypeData = res.data;
        console.log("this.filmTypeData=", this.filmTypeData)
        for (let i = 0; i < this.filmTypeData.length; i++) {
          let fg = false;
          for (let j = 0; j < this.dataFilmType.length; j++) {
            if (parseInt(this.filmTypeData[i].id) == parseInt(this.dataFilmType[j].id)) {
              fg = true;
            }
          }
          this.newFilmType.push({
            'id': this.filmTypeData[i].id,
            'nameEn': this.filmTypeData[i].nameEn,
            'nameTc': this.filmTypeData[i].nameTc,
            'selected': fg
          })
        }
        console.log("this.newFilmType=", this.newFilmType)
      });

  }
  private checkID(id) {
    if (this.data.filmTypeData) {
      for (var i = 0; i < this.data.filmTypeData.length; i++) {
        if (this.data.filmTypeData[i].id == id) {
          return true;
        }
      }
    }
  }
  private changeChecked(id: number) {
    for (let i = 0; i < this.newFilmType.length; i++) {
      if (id == this.newFilmType[i].id) {
        this.newFilmType[i].selected = !this.newFilmType[i].selected;
        //console.log("selected change="+this.newFilmType[i].selected)
        if (this.newFilmType[i].selected) {
          //如果selected，则将film type添加入数组
          this.dataFilmType.push(
            {
              id: this.newFilmType[i].id.toString(),
              nameEn: this.newFilmType[i].nameEn,
              nameTc: this.newFilmType[i].nameTc
            })
          //console.log("this.dataFilmType.new=",this.dataFilmType)
        } else {
          //如果un-selected，则将film type从数组删除
          this.dataFilmType.map((type, idx) => {
            if (parseInt(type.id) == parseInt(this.newFilmType[i].id)) {
              this.dataFilmType.splice(idx, 1);
              //console.log("this.dataFilmType.new=",this.dataFilmType)
            }
          })

        }
      }
    }
  }
  /*private updateAccount(account:any):void{
    account.roles = [];
    for(let i=0;i<this.newFilmType.length;i++){
      if(this.newFilmType[i].selected){
        account.roles.push({'id':this.newFilmType[i].id,'name':this.newFilmType[i].name});
      }
    }
    if(this.data.password == ''){
      delete account.password;
    }
    this.HttpService.postData(API.account,{
      'id':account.id,
      'name':account.name,
      'username':account.username,
      'password':account.password,
      'roles':account.roles
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }*/
  private onReady(str: string): void {
    if (str == 'en') {
      this.contentEn = this.data.contentEn;
    } else if (str == 'tc') {
      this.contentTc = this.data.contentTc;
    }
  }

  private submit(): void {
    this.HttpService.postData(API.film, {
      "active": this.data.active ? 1 : 0,
      "defaultFilm": this.data.defaultFilm ? 1 : 0,
      "contentEn": this.data.contentEn,
      "contentTc": this.data.contentTc,
      "defFree": this.data.defFree,
      "defRecommend": this.data.defRecommend,
      "filmTypes": this.dataFilmType,
      "id": this.id,
      "keyWordsEn": this.data.keyWordsEn,
      "keyWordsTc": this.data.keyWordsTc,
      "titleEn": this.data.titleEn,
      "titleTc": this.data.titleTc,
      "urlEn": this.data.urlEn,
      "urlTc": this.data.urlTc,
      "publishTime": $('#publishTime').val(),
    }).then(res => {
      let data = res;
      if (data.status.code == 0 || data.status.code == '0') {
        this.location.back();
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }
  private onChange(str: string): void {
    if (str == 'en') {
      this.contentEn = this.data.contentEn;
    } else if (str == 'tc') {
      this.contentTc = this.data.contentTc;
    }
  }

  private tempPath: string = API.getTemp;


  //删除时间值
  private removePublishTime() {
    $('#publishTime').val('');
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/film/filmEdit.component.ts